import types from './auditTypes'
import api from '../../../api'
const DEFAULT_QUERY_LIMIT = 25
function handleResponse(context, response) {
  context.commit(types.CLEAR_AUDIT_LOGS)

  setTimeout(() => {
    context.commit(types.SET_AUDIT_LOGS, {
      logs: response.data.results,
    })

    context.dispatch('setAuditCurrentPage', response.data.page)
    context.dispatch('setAuditTotalPages', response.data.pages)
    context.commit(types.SET_TOTAL_ITEMS, {totalItems: response.data.total})
    context.dispatch('hideLoader')
  }, 1000)

  return response.data
}

function handleError(context, err) {
  context.dispatch('hideLoader')
  return err
}

function getFiltersFromContext(context) {
  const filters = context?.state?.filters ?? {}
  return Object.keys(filters).reduce((result, key) => {
    const value = filters[key]?.trim?.()
    if (value) result[key] = value
    return result
  }, {})
}

export default {
  getAllAuditLogs(context) {
    context.dispatch('showLoader')

    const filters = getFiltersFromContext(context)
    const sort = context.state.sort
    const limit = context.state.limit ?? DEFAULT_QUERY_LIMIT
    const page = context.state.currentPage

    return api.audit
      .getAllAuditLogs(filters, page, limit, sort)
      .then(response => {
        return handleResponse(context, response)
      })
      .catch(err => {
        return handleError(context, err)
      })
  },

  getOrganizationAuditLogs(context, payload) {
    context.dispatch('showLoader')

    const organizationId = payload.organizationId
    const filters = getFiltersFromContext(context)
    const sort = context.state.sort
    const limit = context.state.limit ?? DEFAULT_QUERY_LIMIT
    const page = context.state.currentPage

    return api.audit
      .getOrganizationAuditLogs(organizationId, filters, page, limit, sort)
      .then(response => {
        return handleResponse(context, response)
      })
      .catch(err => {
        return handleError(context, err)
      })
  },

  getAccountAuditLogs(context, payload) {
    context.dispatch('showLoader')

    const organizationId = payload.organizationId
    const accountId = payload.accountId
    const filters = getFiltersFromContext(context)
    const sort = context.state.sort
    const limit = context.state.limit ?? DEFAULT_QUERY_LIMIT
    const page = context.state.currentPage

    return api.audit
      .getAccountAuditLogs(
        organizationId,
        accountId,
        filters,
        page,
        limit,
        sort
      )
      .then(response => {
        return handleResponse(context, response)
      })
      .catch(err => {
        return handleError(context, err)
      })
  },

  setAuditFilters(context, filters) {
    context.commit(types.SET_FILTERS, {
      filters: filters,
    })
  },

  clearAuditFilters(context) {
    context.commit(types.CLEAR_FILTERS)
  },

  setAuditTotalPages(context, totalPages) {
    context.commit(types.SET_TOTAL_PAGES, {
      totalPages: totalPages,
    })
  },

  setAuditCurrentPage(context, page) {
    context.commit(types.SET_CURRENT_PAGE, {
      page: page,
    })
  },

  clearAuditCurrentPage(context) {
    context.commit(types.CLEAR_CURRENT_PAGE)
  },

  setAuditSort(context, sort) {
    context.commit(types.SET_SORT, {
      by: sort.by,
      order: sort.order,
    })
  },
}
